/**
 * The Elite Mind section's own vocabulary, mapped onto the panel-wide design
 * tokens in component/common/designSystem/theme.js — the same split
 * moodTheme.js, selfAssessmentTheme.js and homeTestingTheme.js use: only domain
 * meaning lives here, palettes belong to the design system.
 */
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * Symptom → injury → concussion.
 *
 * The one ramp in this whole panel that IS a severity scale, and it earns it:
 * these are escalating degrees of something a club has a duty of care about,
 * and a concussion report an athlete has chosen to share with their club should
 * not be the same colour as a sore hamstring.
 */
export const REPORT_RAMP = [CHART_COLORS.amber, CHART_COLORS.orange, CHART_COLORS.red];

/**
 * How many days out of the last thirty an athlete kept the journal. A daily log
 * is only worth anything if it is actually daily, so this runs sparse-grey to
 * committed-green.
 */
export const CONSISTENCY_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];

/**
 * Training / Competing / Resting, as stated by the athlete on a report they
 * shared. Three states of a season, not three grades — so three distinct hues
 * with no ordering implied.
 */
export const STATUS_RAMP = [CHART_COLORS.blue, CHART_COLORS.brand, CHART_COLORS.teal];
